import { render } from "./SupportDesk.vue?vue&type=template&id=37afe0a9&scoped=true"
import script from "./SupportDesk.vue?vue&type=script&lang=js"
export * from "./SupportDesk.vue?vue&type=script&lang=js"

import "./SupportDesk.vue?vue&type=style&index=0&id=37afe0a9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37afe0a9"]])

export default __exports__